import React, {useState} from "react"
import { useParams, useHistory as useRouterHistory } from 'react-router-dom';
import styles from './AccountingBookSettingsHeader.module.scss';
import PageHeader from '../PageHeader/PageHeader';

function AccountingBookSettingsHeader({ group }){
  const [small, setSmall] = useState(false)
  const { group_id, accounting_book_id } = useParams()
  const routerHistory = useRouterHistory()
  // Return to wherever 設定 was opened (overview / list / settle); fall back to overview.
  const handleBack = () => {
    if (window.history.length > 2) { routerHistory.goBack() }
    else { routerHistory.push(`/liff_entry/groups/${group_id}/accounting_books/${accounting_book_id}/overview`) }
  }

  let classes = [styles.header]
  let iconClasses = [styles.icon, styles.barsIcon]
  let nameClasses = [styles.name]
  let innerBlockClasses = [styles.innerBlock]
  if (small) {
    classes.push(styles.small)
    iconClasses.push(styles.small)
    nameClasses.push(styles.small)
    innerBlockClasses.push(styles.small)
  }

  return(
    <PageHeader
      faicon='faChevronLeft'
      onBack={handleBack}
      color="black">
      設定
    </PageHeader>
  )
}

export default AccountingBookSettingsHeader
//         <TopLeftIcon link={`/liff_entry/groups/${accountingBookDetails.group_id}/accounting_books`} color={themeColors.gold900} faicon='faHome' style={{fontSize: '20px'}}/>

